<template>
  <div id="app">
    <div class="preloader">
      <md-progress
        v-if="pending"
        class="md-blue"
        md-indeterminate
      ></md-progress>
    </div>
    <wb-nav
      v-if="
        isLoggedIn &&
        ($route.path.indexOf('/login') !== 0) &
          ($route.path.indexOf('/externallogin') !== 0) &
          ($route.path.indexOf('/quinyx-sign-in') !== 0) &
          ($route.path.indexOf('/activate') !== 0)
      "
      :vuexUsing="true"
      :navbarItems="navbarItems"
      :profileMenuItems="profileMenuItems"
      :showItems="isLoggedIn"
      :navLogo="logoPath"
      :mainColor="'#43B3FF'"
      :backgroundColor="'#0a2052'"
    ></wb-nav>
    <router-view></router-view>
    <md-icon
      v-if="
        isLoggedIn &&
        ($route.path.indexOf('/login') !== 0) &
          ($route.path.indexOf('/externallogin') !== 0) &
          ($route.path.indexOf('/quinyx-sign-in') !== 0) &
          ($route.path.indexOf('/activate') !== 0)
      "
      :class="['notification-icon', showSidebar ? 'active' : '']"
      @click.native="toggleNotification()"
      >notifications <i>{{ alarmsCount }}</i></md-icon
    >
    <transition
      name="slide-left"
      enter-active-class="slideAppear"
      leave-active-class="slideDisappear"
    >
      <sidebar
        class="sidebar"
        v-if="showSidebar"
        :title="sideBarTitle"
        :headerColor="'#0098FF'"
        @closeSidebar="closeSidebar"
        :type="sideBarType"
        :data="sideBarData"
      ></sidebar>
    </transition>
    <md-snackbar
      :md-position="'bottom left'"
      ref="snackbar"
      :md-duration="2000"
    >
      <span>{{ message }}</span>
    </md-snackbar>
  </div>
</template>
<script>
import wbNav from "wb-nav";
import { mapGetters } from "vuex";
import sidebar from "./components/sidebar.vue";
import managedata from "./helpers/managedata.js";
import utils from "./helpers/utils.js";

const _ = require("underscore");

export default {
  name: "app",
  components: {
    wbNav,
    sidebar,
  },
  mounted() {
    // if (this.$route.path !== '/activate' && this.$route.path !== '/login') {
    //     if ((this.services && this.services.length === 0) || !this.services)
    //         this.$store.dispatch('getServices');
    // }
  },
  methods: {
    closeSidebar: function () {
      this.showSidebar = false;
    },
    toggleNotification: function () {
      this.sideBarType = "notifications";
      this.sideBarTitle = "notification center";
      _.sortBy(_.sortBy(this.alarmMessages, "serviceName"), "time");
      this.sideBarData = this.alarmMessages;
      this.showSidebar = !this.showSidebar;
    },
  },
  data: function () {
    return {
      showSidebar: false,
      sideBarType: "notifications",
      sideBarTitle: "notification center",
      sideBarData: {},
      alarmMessages: [],
    };
  },
  computed: {
    ...mapGetters([
      "message",
      "messageRandom",
      "pending",
      "apps",
      "assignments",
      "route",
      "isLoggedIn",
      "navbarItems",
      "profileMenuItems",
      "services",
    ]),
    navbarItemsLocal() {
      return this.navbarItems;
    },
    alarmsCount() {
      return this.alarmMessages.filter((e) => !e.isRead).length;
    },
    logoPath() {
      if (utils.isQuinyx()) {
        return "/static/quinyx.svg";
      } else {
        return "/static/logo-white.png";
      }
    },
  },
  watch: {
    messageRandom(newValue, oldValue) {
      if (newValue) {
        this.$refs.snackbar.open();
      }
    },
    // isLoggedIn(newValue, oldValue) {
    //   const path = this.$router.currentRoute.path;
    //   const notNeedRedirectPaths = [
    //     "/externallogin",
    //     "/quinyx-sign-in",
    //     "/activate",
    //     "/login",
    //   ];

    //   if (!newValue && !notNeedRedirectPaths.includes(path)) {
    //     this.$router.push("login");
    //   }
    // },
    route(newValue, oldValue) {
      this.$router.push(newValue);
    },
  },
};
</script>
<style>
@font-face {
  font-family: "WidgetBrain";
  src: url("/static/fonts/Montserrat.ttf");
}
.multiselect__content-wrapper {
  /*z-index: 999 !important;*/
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
  z-index: 50 !important;
}

.multiselect__option--highlight,
.multiselect__option--highlight:after {
  background: #0a2052 !important;
}

.multiselect__tag {
  background: #ec217e !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #0a2052 !important;
}

*,
*:after,
*:before {
  box-sizing: border-box;
  outline: none;
}

@font-face {
  font-family: "Bebas";
  src: url("/static/bebas/BebasNeue Bold.otf");
  font-weight: bold;
}

body {
  font-size: 16px;
  font-family: "Helvetica";
  overflow-x: hidden;
}

.md-dialog-container .md-dialog {
  min-width: 480px;
}

#app nav.navbar {
  border-bottom: 1px solid #ccc !important;
  background: #0a2052;
  display: flex;
  align-items: center;
  height: 80px;
  top: 0;
  z-index: 99;
  position: fixed;
  width: 100%;
}

.portal,
.admin {
  padding-top: 80px;
}

#app nav.navbar .nav {
  font-family: "Bebas" !important;
}

input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  background-color: #ffffff !important;
  -webkit-text-fill-color: #2196f3;
  transition: background-color 5000s ease-in-out 0s;
}

#app img.navbar-brand.showed-items {
  border: none;
}

#app nav.navbar a.nav-item.nav-link {
  line-height: 86px;
  font-size: 1.5rem;
}

#app nav.navbar .navbar-brand-image {
  height: 50px !important;
  padding: 0 20px;
}

#app .nav > .nav-item.nav-link > a {
  border: none !important;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
}

#app button.navbar-user-button {
  color: #fff !important;
}

.preloader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999999999999;
}

.main-headline {
  font-weight: 600;
  font-size: 1.5rem;
  text-align: center;
  margin: 0 auto;
}

.main-headline__text {
  padding: 20px;
  max-width: 400px;
  margin: 0 auto;
  border-bottom: 2px solid #e3217c;
}

.md-table .md-table-cell .md-table-cell-container {
  padding-top: 0;
  padding-bottom: 0;
}

.md-table .md-table-cell:last-child .md-table-cell-container {
  padding-left: 0;
}

.multiselect__content-wrapper {
  max-height: 175px !important;
}

.md-dialog-content {
  overflow-y: hidden !important;
}

.md-dialog {
  min-height: 50vh !important;
}

::-webkit-scrollbar {
  width: 7px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  border-radius: 1px;
}

::-webkit-scrollbar-thumb {
  border-radius: 1px;
  /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);*/
  background: #4a90e2;
}

.sidebar {
  z-index: 95;
  position: fixed;
  right: 0;
  top: 80px;
  width: 400px;
  height: calc(100vh - 80px);
  overflow: auto;
  border-left: 1px solid #d4d4d4;
  background: #fff;
}

.slideAppear {
  animation: slideLeft 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slideDisappear {
  animation: slideRight 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

@keyframes slideLeft {
  0% {
    max-width: 0px;
    overflow: hidden;
  }
  100% {
    max-width: 400px;
    overflow: auto;
  }
}

@keyframes slideRight {
  0% {
    max-width: 400px;
    overflow: auto;
  }
  100% {
    max-width: 0px;
    overflow: hidden;
  }
}

i.notification-icon {
  color: #fff;
  z-index: 100;
  left: auto;
  right: 60px;
  top: 27px;
  position: fixed;
  cursor: pointer;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  text-align: center;
  line-height: 28px;
}

i.notification-icon.active {
  background: #ed227d;
  color: #fff;
}

i.notification-icon > i {
  position: absolute;
  right: -10px;
  top: -10px;
  background: #4a90e2;
  color: #fff;
  font-size: 0.65rem;
  border-radius: 4px;
  font-style: normal;
  font-family: "WidgetBrain";
  width: auto;
  height: auto;
  line-height: normal;
  padding: 3px;
}
</style>


// WEBPACK FOOTER //
// App.vue?44376f1e